import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   */
  fetchConsumers: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/consumer/users`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchConsumersFilterList: (): Promise<any> =>
    getRequest(`${config.accountApiUrl}api/super-admin/v1/consumer/list-filters`),
  /**
   * Fetch the Accounts list with pagination
   */
  exportConsumer: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/consumer/export-consumers`, {
      ...parameters,
    });
  },
  /**
   * Fetch the end consumer count report
   */
  endConsumerCountReport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/consumer/users-count`, {
      ...parameters,
    });
  },
  /**
   * Delete the user api call function
   * @param data
   * @returns
   */
  deleteUser: (id: String): Promise<any> => {
    return deleteRequest(`${config.accountApiUrl}api/super-admin/v1/consumer/users/${id}`);
  },
  /**
   * Activity logs for end consumer
   */
  fetchActivityLogs: (id: string, query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(
      `${config.notificationApiUrl}api/super-admin/v1/general-log/consumerActivityLog/${id}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch user info by id
   */
  fetchUserInfoById: (id: string) => {
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/consumer/${id}`);
  },
  /**
   * Fetch vehicle details of the consumer
   */
  fetchVehicleDetailsByUserCustomId: (id: string) => {
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/vehicle-management/consumer/${id}`);
  },
  /**
   * Fetch vehicle details of the consumer
   */
  fetchTransactionByUserCustomId: (id: string) => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-transaction/consumer-transaction-list/${id}`,
    );
  },

  /**
   * Approved password reset function
   * @param id - The facility user ID
   * @param data - The payload (e.g., { newPassword: 'yourPassword' })
   * @returns Promise<any>
   */
  resetPassword: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.accountApiUrl}api/super-admin/v1/consumer/reset-password/${id}`,
      data,
    );
  },
  /**
   * Fetching personal chargers details
   * @param id
   * @returns
   */
  personalChargerDetails: (id: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.commonApiUrl}api/super-admin/v1/charging-point/personal-charging-points/${id}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetching personal chargers history
   * @param id
   * @returns
   */
  personalChargerHistory: (id: string | undefined): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-transaction/consumer-transaction-history/${id}`,
    );
  },
};
